import { MapLike } from '@iotv/iotv-v3-types'

export const getKfromV = <T>(m: MapLike<T>, v: T): keyof typeof m | undefined => Object.keys(m).find((k) => m[k] === v)

export const reverseMap = (m: MapLike<string | number>) => Object.fromEntries(Object.entries(m).map(([k, v]) => [v, k]))

/** reverses numerical enum for use in dropdowns, perhaps */
export const reverseEnum = (e: MapLike<string | number>) =>
  Object.fromEntries(
    Object.entries(e)
      .filter(([k, v]) => typeof v === 'number')
      .map(([k, v]) => [v, k]),
  )
